import Vue from 'vue'
import './slim/slim/slim.css';
import slimCropper from './slim/slim/slim.vue';
Vue.component('slimCropper', slimCropper);
